import Vue from 'vue'

const Bus = new Vue()

export default {
  publish (eventName, payload) {
    Bus.$emit(eventName, payload)
  },
  subscribe (eventName, func) {
    Bus.$on(eventName, func)
  },
  unsubscribe (eventName, func) {
    Bus.$off(eventName, func)
  },
  subscribeOnce (eventName, callback) {
    // removes all listeners from this eventName!!!
    this.subscribe(eventName, (payload) => {
      callback(payload)
      Bus.$off(eventName)
    })
  },
}
